import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { useStore } from '../../contexts/StoreContext';
const nav = [{
  to: '/catalogo',
  label: 'Catálogo 0 km'
}, {
  to: '/marcas',
  label: 'Marcas'
}, {
  to: '/simulador',
  label: 'Simulador'
}, {
  to: '/comparar',
  label: 'Comparar'
}];
export function Header() {
  const {
    compareIds
  } = useStore();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => setOpen(false), [location.pathname]);
  const linkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `relative whitespace-nowrap rounded-lg px-3 py-2 text-sm font-bold uppercase tracking-wide text-white transition-colors duration-150 ${isActive ? 'bg-neon/15 shadow-[inset_0_-2px_0_#4D8CFF]' : 'hover:bg-white/10'}`;
  return <header className="sticky top-0 z-40 border-b border-silver-dark/20 bg-ink/85 backdrop-blur-md" data-id="element-902" data-mp="3uesagbrrs6uc">
      <div className="container-x flex h-16 items-center justify-between gap-4" data-id="element-903" data-mp="6tub561xchbv">
        <div className="flex shrink-0 items-center gap-3" data-id="element-904" data-mp="bsx4vucgf14j">
          <Link to="/" aria-label="VCARS — Inicio" className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-neon" data-id="element-905" data-mp="gmjaj2k7a4qu">
            <Logo showTagline={false} data-id="element-906" data-mp="lme1t77w0wcf" />
          </Link>
          <NavLink to="/" end className={({
          isActive
        }) => `btn h-9 rounded-lg px-4 text-xs font-black tracking-[0.2em] ${isActive ? 'btn-primary' : 'border border-neon/60 text-white hover:bg-neon/15'}`} data-id="element-907" data-mp="3k38gambylafg">
            HOME
          </NavLink>
        </div>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="Principal" data-id="element-908" data-mp="1xwu0xiu76y1">
          {nav.map(n => <NavLink key={n.to} to={n.to} className={linkClass} data-id="element-909" data-mp="19ci337xlsk09">
              {n.label}
              {n.to === '/comparar' && compareIds.length > 0 && <span className="ml-1.5 rounded-full bg-neon px-1.5 py-0.5 text-[10px] font-bold text-white" data-id="element-910" data-mp="3ab2618v90k3j">{compareIds.length}</span>}
            </NavLink>)}
        </nav>

        <div className="hidden items-center gap-2 lg:flex" data-id="element-911" data-mp="3jbrzi5x1dye3">
          <Link to="/chequeo" className="btn btn-credit h-10" data-id="element-912" data-mp="3ee89y9uw1z6u">
            Chequeo crediticio
          </Link>
        </div>

        <button className="rounded-lg p-2 text-white hover:bg-white/5 lg:hidden" onClick={() => setOpen(o => !o)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} data-id="element-913" data-mp="2qnmav82v3p8z">
          {open ? <XIcon className="h-6 w-6" data-id="element-914" data-mp="2vmz01zh7h8eq" /> : <MenuIcon className="h-6 w-6" data-id="element-915" data-mp="2vmp9a9oc6x7z" />}
        </button>
      </div>

      <AnimatePresence data-id="element-916" data-mp="27xect4e0rozn">
        {open && <motion.nav id="mobile-nav" aria-label="Menú móvil" className="border-t border-line bg-ink lg:hidden" initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.18,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-917" data-mp="27w3cxfnp31dt">
            <div className="container-x flex flex-col py-3" data-id="element-918" data-mp="9gvssssdadhi">
              {nav.map(n => <NavLink key={n.to} to={n.to} className={({
            isActive
          }) => `flex items-center justify-between rounded-lg px-3 py-3 text-base font-bold uppercase tracking-wide text-white ${isActive ? 'bg-neon/15' : ''}`} data-id="element-919" data-mp="eee42ptux4so">
                  {n.label}
                  {n.to === '/comparar' && compareIds.length > 0 && <span className="rounded-full bg-neon px-2 py-0.5 text-xs font-bold text-white" data-id="element-920" data-mp="x55k2a8cntg1">{compareIds.length}</span>}
                </NavLink>)}
              <Link to="/chequeo" className="btn btn-credit mt-3 w-full" data-id="element-921" data-mp="3hvmjz450xukr">
                Chequeo crediticio
              </Link>
            </div>
          </motion.nav>}
      </AnimatePresence>
    </header>;
}